import { types } from '../constants';

export const fetchAllEventsForBranchDispatch = (branchId) => ({
  type: types.FETCH_ALL_EVENTS_FOR_BRANCH,
  branchId
});

export const fetchAllEventsForCompanyDispatch = (companyId) => ({
  type: types.FETCH_ALL_EVENTS_FOR_COMPANY,
  companyId
});

export const searchTermChangeForAllEvents = (searchTerm) => ({
  type: types.CHANGE_SEARCH_TERM_ALL_EVENTS,
  searchTerm
});

export const openCreateEventDialogDispatch = (open) => ({
  type: types.OPEN_CREATE_EVENT_DIALOG,
  open
});

export const handleEventInputChangeDispatch = (value, inputFieldName) => ({
  type: types.INPUT_CHANGE_CREATE_EVENT_FORM,
  value,
  inputFieldName
});

export const submitEventDispatch = (event, mode) => ({
  type: types.SUBMIT_EVENT,
  event,
  mode
});

export const openEditEventPanelDispatch = (open) => ({
  type: types.OPEN_EDIT_EVENT_PANEL,
  open
});

export const openEditEventDialogDispatch = (open) => ({
  type: types.OPEN_EDIT_EVENT_DIALOG,
  open
});

export const eventEditClickDispatch = (event) => ({
  type: types.EDIT_EVENT,
  event
});

export const openDeleteEventDialogDispatch = (open, event) => ({
  type: types.OPEN_DELETE_EVENT_DIALOG,
  open,
  event
});

export const submitDeleteEventRequestDispatch = (event) => ({
  type: types.DELETE_EVENT,
  event
});

export const fetchRecordsForTheEventDispatch = (eventId) => ({
  type: types.FETCH_RECORDS_FOR_THE_EVENT,
  eventId
});

export const handleDeleteEventRecordClickDispatch = (payload) => ({
  type: types.DELETE_EVENT_RECORD,
  payload
});

export const submitRecordDispatch = (payload, mode, branchId) => ({
  type: types.SUBMIT_EVENT_RECORD,
  payload,
  mode,
  branchId
});

export const enableEditEventRecordDispatch = (
  enableEditRecordMode,
  recordId
) => ({
  type: types.ENABLE_EDIT_EVENT_RECORD,
  enableEditRecordMode,
  recordId
});

export const handleEditEventRecordInputChangeDispatch = (
  value,
  inputFieldName
) => ({
  type: types.INPUT_CHANGE_EDIT_EVENT_RECORD,
  value,
  inputFieldName
});

export const openAddEventRecordDialogDispatch = (open) => ({
  type: types.OPEN_ADD_EVENT_RECORD_DIALOG,
  open
});

export const removeEventRecordAttachment = (attachment) => ({
  type: types.REMOVE_EVENT_RECORD_ATTACHMENT,
  attachment
});

export const fetchExistingAttachmentsForTheEventRecordDispatch = (
  domainTypeId,
  parentId,
  loggedInUserId
) => ({
  type: types.LOAD_ATTACHMENTS_FOR_EVENT_RECORD,
  domainTypeId,
  parentId,
  loggedInUserId
});

export const removeEventRecordAttachmentEdit = (attachment) => ({
  type: types.REMOVE_EVENT_RECORD_ATTACHMENT_EDIT,
  attachment
});
